/**
 * Date formatting — handles the shapes the backend returns:
 *  - Firebase timestamp objects: { _seconds, _nanoseconds }
 *  - epoch millis / Date / ISO strings
 * Returns "DD MMM YYYY" (or "" for missing/invalid), with no moment.js dependency.
 */
const FMT = new Intl.DateTimeFormat("en-GB", {
  day: "2-digit",
  month: "short",
  year: "numeric",
});

/** Coerce any of the supported backend shapes into a Date (or null). */
export function toDate(value) {
  if (value == null || value === "") return null;
  let date;
  if (typeof value === "object" && value._seconds != null) {
    date = new Date(value._seconds * 1000);
  } else if (value instanceof Date) {
    date = value;
  } else {
    date = new Date(value);
  }
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDate(value) {
  const date = toDate(value);
  return date ? FMT.format(date) : "";
}

/**
 * Format a value for an <input type="date"> (local "YYYY-MM-DD").
 */
export function toDateInput(value) {
  const date = toDate(value);
  if (!date) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

/**
 * Format a value for an <input type="datetime-local"> (local "YYYY-MM-DDTHH:mm").
 */
export function toDateTimeLocal(value) {
  const date = toDate(value);
  if (!date) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
}
